var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.455,
    height: 14,
    viewBox: "0 0 11.455 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-3.001 -0.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31430",
    "data-name": "Path 31430",
    d: "M12.366,2.3a5.725,5.725,0,1,0-7.124,8.963,9.7,9.7,0,0,1,2.5,2.684l.445.741a.636.636,0,0,0,1.091,0l.427-.711a8.1,8.1,0,0,1,2.277-2.545A5.721,5.721,0,0,0,12.367,2.3ZM8.728,9.272a2.545,2.545,0,1,1,2.545-2.545A2.545,2.545,0,0,1,8.728,9.272Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationWhite);
export default __webpack_public_path__ + "static/media/location_white.fe863d9a51b669e1466d0db5cd949d91.svg";
export { ForwardRef as ReactComponent };